import { MenuItem } from "@mui/material";
import { Proposal } from "generated/graphql";
import { Link } from "react-router-dom";
import { getRoute } from "utils/routing";

export default function UpdateProposalMenuItem({
  closeMenu,
  id,
}: {
  closeMenu: () => void;
  id: Proposal["id"];
}) {
  return (
    <MenuItem
      data-test-id="action-update"
      component={Link}
      onClick={closeMenu}
      to={getRoute("proposals.draft", [["proposalId", id]])}
    >
      Update
    </MenuItem>
  );
}
